import React, { useState, useContext, useEffect } from "react";
import Select from 'react-select';
import './ProcedimientoForm.css';

import Swal from 'sweetalert2'

import activoTypeContext from '../../context/activoTypeContex/activoTypeContex.js';
import procedimientoContext from "../../context/procedimientoContext/procedimientoContext.js";
import TareasSubtabla from "../tareasSubtabla/TareasSubtabla.js";
import ProductosSubtabla from "../productosSubtabla/ProductosSubtabla.js"

import { estructuraProcedimientoForm, estructura_producto, estructuraTarea, unidadesMedidasOpciones, opcionesTipoProcedimiento, opcionesProgramarAl, estructuraCategoriaAsociada, createEstructuraChecklistsByProcedimiento, createEstructuraProcedimientoForm } from "../../utils/estructuras.js";

import CategoriasRRHHSubtabla from "../categoriasRRHHSubtabla/CategoriasRRHHSubtabla.js";
import ChecklistsSubtabla from "../checklistsSubtabla/ChecklistsSubtabla.js";


const ProcedimientoForm = ({procToModify, setShowABM, setProcToModify}) =>{

    const [mode,setMode] = useState((Object.keys(procToModify).length > 0 && procToModify.fromActivo == undefined) ? 'edit' : 'new'); 
    const [procedimiento,setProcedimiento] = useState((Object.keys(procToModify).length > 0) ? {...createEstructuraProcedimientoForm(), ...procToModify} : {...createEstructuraProcedimientoForm()});

    const [emptyInputs,setEmptyInputs] = useState([]); //Estado que almacena todos los inputs vacios pendientes de informacion.
    
    const [options,setOptions] = useState({activosType:[], procedimientosOptions:[], tipoProcedimientos: opcionesTipoProcedimiento, unidadesMedidasOpciones: [...unidadesMedidasOpciones,{value:'DAYS',label:'Días'}]}) //Estado que almacena todas las opciones seleccionables en los SelectControl.

    const [tablaSeleccionada,setTablaSeleccionada] = useState("tareas"); //Estado que indica que tabla hija renderizar.

    const atContext = useContext(activoTypeContext);
    const {activoTypeList} = atContext;

    const pContext = useContext(procedimientoContext);
    const {actualizarProcedimientoList, agregarProcedimiento, modificarProcedimiento, procedimientoList} = pContext;

    const removeCampoVacio = (toRemove) => {
        //logica para inputs vacios.
    }

    const handleChange = (e,property=null,value=null) =>{
        if(property !== null && value !== null){
            //Functional update ya que cada total invoca setRequeriment y no llega a tomar el ultimo valor si no.
            removeCampoVacio(property);
            setProcedimiento(prevProc => {
                const newMant = {...prevProc,[property]:value};
                return newMant;
            })
        }else{
            if(e.target.value == ""){
                    setEmptyInputs(prevEmptyInputs => {
                    let newEmptyI = prevEmptyInputs.slice();
                    newEmptyI.push(e.target.name);
                    return newEmptyI;
                })
            }else removeCampoVacio(e.target.name);
            setProcedimiento({...procedimiento,[e.target.name]:e.target.value})
        }
    }

    const createOptions = () =>{
        let optionsProcedimientos = procedimientoList.filter(p => procToModify != {} ? p.codProc != procToModify.codProc : true).map(p => { return {value:p.codProc, label: p.name, id: p._id}});
        let optionsActivos = activoTypeList.map((a) =>  { return {value:a.codTypeActivo,label:a.nameTypeActivo}});
        setOptions({...options,['activosType']:optionsActivos,['procedimientosOptions']:optionsProcedimientos});
    }

    const handleChangeProductos = (prod={}, i, property = '', value = '') => {
        
        //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
        setProcedimiento((prevProc) => {
            const actualList = prevProc.productos.slice();
            if(property != '' && value != '' && Object.keys(prod).length == 0){  
                actualList[i][property] = value;
            }else if(property != ''){
                actualList[i][property] = value;
            }
            else{
                const prodTemp = {...prod, user_id: (Math.random() * 100).toString()};
                const nuevaEstructura = {...estructura_producto, user_id: (Math.random() * 100).toString()};
                if(prod.tipPro != ''){
                    if(actualList[i].tipPro !== ''){
                        actualList[i] = prodTemp;
                    }else{
                        actualList[i] = prodTemp;
                        actualList.push(nuevaEstructura);
                    }
                }
            }
            let newProc = {...procedimiento,['productos']:actualList}
            return newProc;
        })
//        setProcedimiento({...procedimiento,productos:actualList})
    }

    const handleDeleteProd = (prod, index) => {
        let actualProductos = procedimiento.productos.slice();

        if(prod.tipPro != ''){
            let productosToUpdate = actualProductos.filter((p,i) => i != index);
            setProcedimiento({...procedimiento,['productos']:productosToUpdate});
        }
    }

    const handleChangeCategorias = (categoria = {}, i,  property = '', value = '') =>{
        //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
        setProcedimiento((prevProc) => {
            const actualList = prevProc.categorias.slice();
            if(actualList[i].categoria?.label == '' && property == 'categoria') actualList.push({...estructuraCategoriaAsociada});
            if(property != '' && value != '' && Object.keys(categoria).length == 0){  
                actualList[i][property] = value;
            }else if(property != ''){
                actualList[i][property] = value;
            }
            let newProc = {...procedimiento,['categorias']:actualList}
            return newProc;
        })
    }

    const handleDeleteCategoria = (categoria, index) =>{
        let actualCategorias = procedimiento.categorias.slice();

        if(actualCategorias[index].categoria.label != ''){
            let categoriasToUpdate = actualCategorias.filter((c,i) => i != index);
            setProcedimiento({...procedimiento,['categorias']:categoriasToUpdate});
        }
    }
    
    const handleChangeChecklists = (categoria = {}, i,  property = '', value = '') =>{
        //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
        setProcedimiento((prevProc) => {
            const actualList = prevProc.checklists.slice();
            if(actualList[i].checklist?.label == '' && property == 'checklist') actualList.push(createEstructuraChecklistsByProcedimiento());
            if(property != '' && value != '' && Object.keys(categoria).length == 0){  
                actualList[i][property] = value;
            }else if(property != ''){
                actualList[i][property] = value;
            }
            let newProc = {...procedimiento,['checklists']:actualList}
            return newProc;
        })
    }

    const handleDeleteChecklist = (categoria, index) =>{
        let actualChecklists = procedimiento.checklists.slice();

        if(actualChecklists[index].checklist.label != ''){
            let checklistsToUpdate = actualChecklists.filter((c,i) => i != index);
            setProcedimiento({...procedimiento,['checklists']:checklistsToUpdate});
        }
    }

    const handleSaveProcedimiento = async () => {
        let procedimientoToSave;
        let _id;
        procedimientoToSave = {...procedimiento};
        if(procedimientoToSave.codProc == '' || procedimientoToSave.name == ''){
            Swal.fire({
                title: "Complete el codigo y/o nombre del procedimiento",
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
            return;
        }
        //Se omite la ultima tarea y producto en vacio, dejando solo las que deben ser guardadas.
        let tareas = procedimientoToSave.tareas.filter((t) => t.label != ""); 
        if(tareas.length == 0){
            Swal.fire({
                title: "El procedimiento debe tener al menos una tarea",
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
            return;
        }

        if(procedimientoToSave.tipProc.value == ''){
            Swal.fire({
                title: "Defina el Tipo de Procedimiento",
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
            return;
        }

        let productos = procedimientoToSave.productos.filter((p) => p.tipPro != "");
        let categorias = procedimientoToSave.categorias.filter(c => c.categoria.label != ''); 
        let checklists = procedimientoToSave.checklists.filter(c => c.checklist.label != ''); 

        //Se crea una cadena string de los activos, obteniendo su codigo y separandolos con un -
        if(procedimientoToSave.tipAct.length > 0){
            let activos = procedimientoToSave.tipAct.slice(); 
            procedimientoToSave.tipAct = activos.map((a) => a.value).join(' , '); 
            procedimientoToSave.activos = procedimientoToSave.tipAct[0].label; 
        }else procedimientoToSave.tipAct = '';

        if(procedimientoToSave.incluidoEn.length > 0){
            let incluidoEn = procedimientoToSave.incluidoEn.slice();
            incluidoEn = incluidoEn.map(a => a.value).join(' , ');
            procedimientoToSave.incluidoEn = incluidoEn;
        }else procedimientoToSave.incluidoEn = '';
        
        procedimientoToSave.tareas = tareas; 
        procedimientoToSave.productos = productos; 
        procedimientoToSave.categorias = categorias;
        procedimientoToSave.checklists = checklists;
        procedimientoToSave.uniMed = procedimientoToSave.uniMed?.value;
        procedimientoToSave.uniMed2 = procedimientoToSave.uniMed2?.value;
        procedimientoToSave.tipProc = procedimientoToSave.tipProc.value;
        procedimientoToSave.programarAl = procedimientoToSave.programarAl?.value;
        //Se invoca la funcion del contexto para guardar el mantenimiento.
        let procedimientoSaved = await agregarProcedimiento(procedimientoToSave); 
        
        if(procedimientoSaved == 'DUPLICATEKEY') Swal.fire({
            title: `Ya existe un procedimiento con ese codigo`,
            icon: 'error',
            showConfirmButton: true,
            allowEnterKey: true
        });
        else{
            if(procedimientoSaved != undefined) Swal.fire({
                title: `Se guardo un nuevo procedimiento`,
                icon: 'success',
                showConfirmButton: true,
                allowEnterKey: true
            });
            setProcedimiento({...estructuraProcedimientoForm});
            setProcToModify({});
            setShowABM(true);
            actualizarProcedimientoList();
        }
    }

    const handleUpdateProcedimiento = async () =>{
        let procedimientoToUpdate;
        procedimientoToUpdate = {...procedimiento};
        //Se omite la ultima tarea en vacio, dejando solo las que deben ser guardadas.
        let tareas = procedimientoToUpdate.tareas.filter((t) => t.label != ""); 
        let productos = procedimientoToUpdate.productos.filter((p) => p.tipPro != "");
        let categorias = procedimientoToUpdate.categorias.filter(c => c.categoria.label != ''); 
        let checklists = procedimientoToUpdate.checklists.filter(c => c.checklist.label != ''); 

        if(procedimientoToUpdate.owner == 'system'){
            Swal.fire({
                title: "Este procedimiento es creado por el sistema y el mismo no permite modificarlo",
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
            return;
        }
        
        if(tareas.length == 0){
            Swal.fire({
                title: "El procedimiento debe tener al menos una tarea",
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
            return;
        }

        //Se crea una cadena string de los activos, obteniendo su codigo y separandolos con un -
        if(procedimientoToUpdate.tipAct.length > 0){
            let activos = procedimientoToUpdate.tipAct.slice(); 
            procedimientoToUpdate.tipAct = activos.map((a) => a.value).join(' , '); 
            procedimientoToUpdate.activos = procedimientoToUpdate.tipAct[0].label; 
            procedimientoToUpdate.activos = procedimientoToUpdate.tipAct[0].label; //Revisar que guardar de cada activo.
        }else procedimientoToUpdate.tipAct = '';

        if(procedimientoToUpdate.incluidoEn.length > 0){
            let incluidoEn = procedimientoToUpdate.incluidoEn.slice();
            incluidoEn = incluidoEn.map(a => a.value).join(' , ');
            procedimientoToUpdate.incluidoEn = incluidoEn;
        }else procedimientoToUpdate.incluidoEn = '';
        
        procedimientoToUpdate.tareas = tareas; 
        procedimientoToUpdate.productos = productos;
        procedimientoToUpdate.categorias = categorias;
        procedimientoToUpdate.checklists = checklists;
        procedimientoToUpdate.uniMed = procedimientoToUpdate.uniMed?.value;
        procedimientoToUpdate.uniMed2 = procedimientoToUpdate.uniMed2?.value;
        procedimientoToUpdate.tipProc = procedimientoToUpdate.tipProc.value;
        procedimientoToUpdate.programarAl = procedimientoToUpdate.programarAl?.value;
        
        //Se invoca la funcion del contexto para guardar el mantenimiento.
        let procedimientoSaved = await modificarProcedimiento(procedimientoToUpdate); 
        
        if(procedimientoSaved?.codProc != undefined) Swal.fire({
                title: `Se actualizo el procedimiento correctamente`,
                icon: 'success',
                showConfirmButton: true,
                allowEnterKey: true
            });
        else if(procedimientoSaved?.message != undefined) Swal.fire({
            title: `${procedimientoSaved.message}`,
            icon: 'error',
            showConfirmButton: true,
            allowEnterKey: true
        });
        setProcedimiento({...estructuraProcedimientoForm});
        setProcToModify({});
        setShowABM(true);
        actualizarProcedimientoList();
    }

    const handleClickCancel = () =>{
        Swal.fire({
            title: 'Está seguro que desea cancelar?',
            showDenyButton: true,
            confirmButtonText: 'Sí, Cancelar',
            confirmButtonColor: '#ff0000',
            denyButtonColor: '#3d4d87',
            denyButtonText: 'No',
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                setShowABM(true);
                setProcToModify({});
            } 
        })
    }

    const handleTipoActivosByProcedimiento = (value) => {
        let procFound = procedimientoList.find(p => p.codProc == value.value);
        let activosAlreadySelected = procFound.tipAct.split(",").map((a) => a.trim()); 
        //Por el codigo de tipo activo trae toda su info filtrada
        let tipActFiltered = activoTypeList.filter((a) => activosAlreadySelected.includes(a.codTypeActivo)).map((a) => { return {value:a.codTypeActivo,label:a.nameTypeActivo}}); 
        tipActFiltered = tipActFiltered.filter(a => !(procedimiento.tipAct.some(tA => tA.value == a.value)));
        setProcedimiento({...procedimiento, tipAct:[...procedimiento.tipAct, ...tipActFiltered]});
    }

    useEffect(()=>{ 
        //useEffect que al recibir los activos, modela sus valores para adaptarlos al Select Multiple Valor.
        createOptions()
    },[activoTypeList]);

    useEffect(() => {
        if(mode == 'edit'){
            //Si no tienen valores seteados y fue guardado igual, se setearan los iniciales vacios.
            let activosFiltered = [];
            let procedimientosIncluidosFiltered = [];
            let productos = [{...estructura_producto}];
            let tareas = [{...estructuraTarea}];
            let categorias = [{...estructuraCategoriaAsociada}];
            let checklists = [createEstructuraChecklistsByProcedimiento()];
            
            if(procToModify.tipAct != '' && procToModify.tipAct != undefined){
                //Separa los tipos de activos obtenidos en cadena String en elementos de un array
                let activosAlreadySelected = procToModify.tipAct.split(",").map((a) => a.trim()); 
                //Por el codigo de tipo activo trae toda su info filtrada
                activosFiltered = activoTypeList.filter((a) => activosAlreadySelected.includes(a.codTypeActivo)); 
                //Crea las opciones ya seleccionadas para el select control.
                activosFiltered = activosFiltered.map((a) => { return {value:a.codTypeActivo,label:a.nameTypeActivo}}) 
            }
            if(procToModify.incluidoEn != undefined && procToModify.incluidoEn != ''){
                let incluidosAlreadySelected = procToModify.incluidoEn.split(",").map(a => a.trim());
                procedimientosIncluidosFiltered = procedimientoList.filter(p => incluidosAlreadySelected.includes(p.codProc))
                procedimientosIncluidosFiltered = procedimientosIncluidosFiltered.map(p => {return {value: p.codProc, label:p.name, id: p._id}});
            }
            if(procToModify.productos.length > 0){
                productos = procToModify.productos.slice();
                productos.push(estructura_producto);
            }
            if(procToModify.tareas.length > 0){
                //tareas = procToModify.tareas.slice();
                tareas = procToModify.tareas.map((t) => (t.codTarea != undefined) ? {descrp: t.descrp, showDescrp: t.showDescrp, value: t.codTarea, id: t.id, name: t.name, label:t.descrp, taskDescrp:t.taskDescrp, fecMod: t.fecMod, fecAlt: t.fecAlt, relacionId: t.tareaXprocedimientID} : {...t})
                tareas.push(estructuraTarea);
            }
            if(procToModify.categorias != undefined && procToModify.categorias.length > 0){
                categorias = procToModify.categorias.slice();
                categorias.push({...estructuraCategoriaAsociada});
            }
            if(procToModify.checklists.length > 0){
                checklists = procToModify.checklists.slice();
                checklists.push(createEstructuraChecklistsByProcedimiento());
            }
            setProcedimiento({...procedimiento,productos:productos,tareas:tareas,tipAct:activosFiltered,incluidoEn:procedimientosIncluidosFiltered,categorias:categorias,checklists:checklists});
        }
    },[procToModify]);

    return <div className="procedimientosDiv">
        <div className="procedimientoForm">
            <div className="procedimientoFormHeader">
                <div className="inputGroup" id="codigoInputGroup">
                    <label>Código</label>
                    <input disabled={mode == 'edit'} name="codProc" value={procedimiento.codProc} onChange={(e) => handleChange(e)}/>
                </div>
                <div className="inputGroup" id="descripcionInputGroup">
                    <label>Nombre</label>
                    <input name="name" value={procedimiento.name} onChange={(e) => handleChange(e)}/>
                </div>
            </div>
            <div className="inputGroup" id="inputGroupMultiSelect">
                <label>Tipo de Procedimiento</label>
                <Select
                    styles={{
                        container: base => ({
                            ...base,
                            flexGrow:1
                        })
                    }}                
                    placeholder=""
                    options={options.tipoProcedimientos}
                    value={procedimiento.tipProc}
                    onChange={(value)=>handleChange(null,"tipProc",value)}
                />
            </div>
            <div className="groupTipActContainer">
                <div className="facilitadorTipActsByProcedimiento">
                    <label>Recuperar desde procedimiento</label>
                    <Select 
                        styles={{
                            container: base => ({
                                ...base,
                                width:'75%',
                            }),
                        }}
                        value={{}}
                        options={options.procedimientosOptions}
                        onChange={(value)=>handleTipoActivosByProcedimiento(value)}
                    />
                </div>
                <div className="inputGroup" id="inputGroupMultiSelect">
                    <label>Tipo Activo</label>
                    <Select
                        styles={{
                            container: base => ({
                                ...base,
                                flexGrow:1
                            }),
                            multiValueLabel: (base) => ({
                            ...base,
                            boxShadow:"none",
                            backgroundColor: "#6b9080",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                            }), 
                            multiValueRemove: (base) => ({
                                ...base,
                                backgroundColor: "#6b9080",
                                color: 'white',
                                borderRadius: "none",
                                fontSize: "1rem"
                            }),
                        }}
                        isMulti
                        placeholder=""
                        options={options.activosType}
                        value={procedimiento.tipAct}
                        onChange={(value)=>handleChange(null,"tipAct",value)}
                    />
                </div>
            </div>

            <div className="inputGroup" id="inputGroupMultiSelect">
                <label>Incluido en...</label>
                <Select
                    styles={{
                        container: base => ({
                            ...base,
                            flexGrow:1
                        }),
                        multiValueLabel: (base) => ({
                        ...base,
                        boxShadow:"none",
                        backgroundColor: "#6b9080",
                        color: 'white',
                        borderRadius: "none",
                        fontSize: "1rem"
                        }), 
                        multiValueRemove: (base) => ({
                            ...base,
                            backgroundColor: "#6b9080",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }),
                    }}
                    isMulti
                    placeholder=""
                    options={options.procedimientosOptions}
                    value={procedimiento.incluidoEn}
                    onChange={(value)=>handleChange(null,"incluidoEn",value)}
                />
            </div>
            <div className="inputGroup" id="inputGroupTextAdic">
                <label>Duración en Horas</label>
                <input type="number" name="valInicio" onChange={(e) => handleChange(e)} value={procedimiento.valInicio}/>
            </div>
            <div className="inputGroup" id="inputGroupTextAdic">
                <label>Texto Adicional</label>
                <textarea placeholder="Ingrese texto adicional" name="descrp" value={procedimiento.descrp} onChange={(e) => handleChange(e)}/>
            </div>
            {
                (procedimiento.tipProc != undefined && procedimiento.tipProc.value && procedimiento.tipProc.value != 'CORRECTIVO' &&  procedimiento.tipProc.value != 'MEJORA') && <div className="alertaProcedimientoDiv">
                    <>
                        <label id="alertaLabel">Alerta</label>

                        <div className="inputGroup" id="programarAlInputGroup">
                            <label>Programar al ...</label>
                            <div className="programarAlRow">
                                <Select
                                    styles={{
                                        container: (base) => ({
                                            ...base,
                                            width: '40%'
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            width: "100%",
                                            padding: ".4rem",
                                            borderRadius: ".5rem",
                                            fontSize: "1rem",
                                            transition: "border-color .5s"
                                        })
                                    }}
                                    placeholder=""
                                    options={opcionesProgramarAl}
                                    value={procedimiento.programarAl}
                                    onChange={(selectedOption) => handleChange(null,'programarAl',selectedOption)}
                                />
                                {procedimiento.programarAl?.value !== 'ULTIMOCREADO' && <>
                                    <div className="inputGroup" id="cadaMesesInputGroup">
                                        <label>Cada</label>
                                        <div className="noContabilizaInputGroup">
                                            <input type="number" name="cadaMeses" value={procedimiento.cadaMeses || 1} onChange={(e) => handleChange(e)}/>
                                            <span>meses</span>
                                        </div>
                                    </div>
                                    <div className="inputGroup" id="visibleSupervisor">
                                        <label>Visible para perfil Supervisor</label>
                                        <input type="checkbox" checked={procedimiento.supervisorVisible} onChange={(e)=>setProcedimiento({...procedimiento, supervisorVisible: e.target.checked})}/>
                                    </div>
                                </>}
                            </div>
                        </div>
                    </>
                    {(procedimiento.programarAl?.value ?? 'ULTIMOCREADO') === 'ULTIMOCREADO' && <>
                        <div className="alertaProcedimientoForm">
                            <div className="inputGroup" id="alertaProcUNIMED">
                                <label>Unidad Medida</label>
                                <Select
                                styles={{
                                    container: (base) => ({
                                        ...base,
                                        width: '100%'
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        width: "100%",
                                        padding: ".4rem",
                                        borderRadius: ".5rem",
                                        fontSize: "1rem",
                                        transition: "border-color .5s"
                                    })
                                }}
                                placeholder="Elija unidad de medida..."
                                options={options.unidadesMedidasOpciones}
                                value={procedimiento.uniMed}
                                onChange={(selectedOption) => handleChange(null,'uniMed',selectedOption)}
                                />
                                {procedimiento.uniMed?.value == 'DAYS' && <div className="inputGroup" id="visibleSupervisor">
                                    <div className="noContabilizaInputGroup">
                                        <label>No contabilizar días Fuera de Servicio para el cálculo</label>
                                        <input type="checkbox" checked={procedimiento.noContabilizaFSERV} onChange={(e)=>setProcedimiento({...procedimiento, noContabilizaFSERV: e.target.checked})}/>
                                    </div>
                                    <span>Ejemplo si se tilda: para un servicio cada 30 días el último mantenimiento se completó el 20/01/2025 , pero el activo estuvo fuera de servicio 5 días, el próximo mantenimiento vencerá el 25/02/2025 en vez del 20/02/2025.</span>
                                </div>}
                            </div>
                            <div className="inputGroup" id="alertaProcCada">
                                <label>Cada</label>
                                <input type="number" name="valorCada" value={procedimiento.valorCada} onChange={(e) => handleChange(e)}/>
                            </div>
                            <div className="inputGroup" id="alertaProcAnticipo">
                                <label>Alerta Anticipo</label>
                                <input type="number" name="alertAnticipo" value={procedimiento.alertAnticipo} onChange={(e) => handleChange(e)}/>
                            </div>
                            <div className="inputGroup" id="visibleSupervisor">
                                <label>Visible para perfil Supervisor</label>
                                <input type="checkbox" checked={procedimiento.supervisorVisible} onChange={(e)=>setProcedimiento({...procedimiento, supervisorVisible: e.target.checked})}/>
                            </div>
                        </div>
                    </>}
                    {(procedimiento.programarAl?.value ?? 'ULTIMOCREADO') === 'ULTIMOCREADO' && <>
                        <div className="alertaProcedimientoForm">
                            <div className="inputGroup" id="alertaProcUNIMED">
                                <label>Unidad Medida 2</label>
                                <Select
                                styles={{
                                    container: (base) => ({
                                        ...base,
                                        width: '100%'
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        width: "100%",
                                        padding: ".4rem",
                                        borderRadius: ".5rem",
                                        fontSize: "1rem",
                                        transition: "border-color .5s"
                                    })
                                }}
                                placeholder="Elija unidad de medida secundaria..."
                                options={options.unidadesMedidasOpciones}
                                value={procedimiento.uniMed2}
                                onChange={(selectedOption) => handleChange(null,'uniMed2',selectedOption)}
                                />
                                {procedimiento.uniMed2?.value == 'DAYS' && <div className="inputGroup" id="visibleSupervisor">
                                    <div className="noContabilizaInputGroup">
                                        <label>No contabilizar días Fuera de Servicio para el cálculo</label>
                                        <input type="checkbox" checked={procedimiento.noContabilizaFSERV} onChange={(e)=>setProcedimiento({...procedimiento, noContabilizaFSERV: e.target.checked})}/>
                                    </div>
                                    <span>Ejemplo si se tilda: para un servicio cada 30 días el último mantenimiento se completó el 20/01/2025 , pero el activo estuvo fuera de servicio 5 días, el próximo mantenimiento vencerá el 25/02/2025 en vez del 20/02/2025.</span>
                                </div>}
                            </div>
                            <div className="inputGroup" id="alertaProcCada">
                                <label>Cada</label>
                                <input type="number" name="valorCada2" value={procedimiento.valorCada2} onChange={(e) => handleChange(e)}/>
                            </div>
                            <div className="inputGroup" id="alertaProcAnticipo">
                                <label>Alerta Anticipo</label>
                                <input type="number" name="alertAnticipo2" value={procedimiento.alertAnticipo2} onChange={(e) => handleChange(e)}/>
                            </div>
                        </div>
                    </>}
                </div>
            }

            {
                (procedimiento.tipProc != undefined && procedimiento.tipProc.value == 'CORRECTIVO') && <div className="alertaProcedimientoDiv">
                    <label id="alertaLabel">Acciones Automáticas</label>
                    <div className="procedimientoModificaStatusActForm">
                        <div className="inputGroup" id="visibleSupervisor">
                                <label>Activo Fuera de Servicio al crear ODT</label>
                                <input type="checkbox" checked={procedimiento.disableActivo} onChange={(e)=>setProcedimiento({...procedimiento, disableActivo: e.target.checked})}/>
                        </div>
                        <div className="inputGroup" id="visibleSupervisor">
                                <label>Impide setear Activo en Disponible hasta Finalizar ODT</label>
                                <input type="checkbox" checked={procedimiento.notAllowEnableActivo} onChange={(e)=>setProcedimiento({...procedimiento, notAllowEnableActivo: e.target.checked})}/>
                        </div>
                        <div className="inputGroup" id="visibleSupervisor">
                                <label>Activo Disponible al Finalizar ODT</label>
                                <input type="checkbox" checked={procedimiento.enableActivo} onChange={(e)=>setProcedimiento({...procedimiento, enableActivo: e.target.checked})}/>
                        </div>
                    </div>
                </div>
            }

            <div className="tablasHijasDiv">
                <div className="opcionesHijasDiv">
                    <button className={(tablaSeleccionada === 'tareas') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('tareas')}>Tareas</button>
                    <button className={(tablaSeleccionada === 'componentes') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('componentes')}>Materiales</button>
                    <button className={(tablaSeleccionada === 'catsRRHH') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('catsRRHH')}>Categorias Asociadas</button>
                    <button className={(tablaSeleccionada === 'checklists') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('checklists')}>Checklists Asociados</button>
                </div>
                <TareasSubtabla tareas={procedimiento.tareas} setState={setProcedimiento} procedimiento={procedimiento} tablaSeleccionada={tablaSeleccionada} tipo={'tareaMant'} tDocID={procToModify._id} optionsProcedimientos={options.procedimientosOptions} procedimientoList={procedimientoList} componentePadre={'ProcedimientoForm'}/> 
                <ProductosSubtabla productos={procedimiento.productos} handleChangeProductos={handleChangeProductos} handleDeleteProd={handleDeleteProd} tablaSeleccionada={tablaSeleccionada}/>
                <CategoriasRRHHSubtabla categorias={procedimiento.categorias} handleChangeCategorias={handleChangeCategorias} handleDeleteCategoria={handleDeleteCategoria} tablaSeleccionada={tablaSeleccionada} modo={mode}/>
                <ChecklistsSubtabla checklists={procedimiento.checklists} handleChangeChecklists={handleChangeChecklists} handleDeleteChecklist={handleDeleteChecklist} tablaSeleccionada={tablaSeleccionada} modo={mode}/>
            </div>
            <div className="functionsDiv">
                {(mode == 'new') ? <button className="saveProcBtn" onClick={()=>handleSaveProcedimiento()}>Guardar</button> : <button className="saveProcBtn" onClick={()=>handleUpdateProcedimiento()}>Guardar cambios</button>}
                <button className="cancelProcBtn" onClick={()=>handleClickCancel()}>Cancelar</button>

            </div>
        </div>
    </div>

}

export default ProcedimientoForm;